import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default function (param) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: '',
    name: 'GET_ENERGETEMPLATE',
  });

  const manualRequest = function () {
    if (param && JSON.stringify(param) !== '{}') {
      let url = '/api/energetemplate';
      let arr = [];
      Object.keys(param).forEach(key => {
        arr.push(key + '=' + param[key]);
      });
      if (arr.length !== 0) {
        url += '?' + arr.join('&');
      }
      exec(url);
    }
  };

  useEffect(() => {
    manualRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return [isRequestSuccessed, data || {}, manualRequest];
}
